<div
  [ngClass]="{
    input: !(formControl.invalid && formControl.touched),
    'input-error': formControl.invalid && formControl.touched
  }"
>
  <label class="input-label-item" for="{{ for }}">{{ label }}</label>
  <textarea
    class="input-head-item"
    placeholder="{{ label }}"
    [formControl]="formControl"
    [rows]="rows"
  ></textarea>
  @if (formControl.invalid && formControl.touched) {
    <div>
      @if (formControl.errors?.['required']) {
        <div class="input-error">Este campo es requerido</div>
      }
      @if (formControl.errors?.['minlength']) {
        <div class="input-error">No cumple la longitud mínima</div>
      }
      @if (formControl.errors?.['maxlength']) {
        <div class="input-error">No cumple la longitud máxima</div>
      }
      @if (formControl.errors?.['invalidPattern']) {
        <div class="input-error">
          El campo contiene caracteres no permitidos
        </div>
      }
    </div>
  }
  @if (helpLabel) {
    <div class="input-help-label">{{ helpLabel }}</div>
  }
</div>
